import React from 'react';

interface FadeWrapperProps {
  children: React.ReactNode;
}

const FadeWrapper = ({ children }: FadeWrapperProps): JSX.Element => {
  return (
    <div
      className="relative after:absolute after:bottom-0 after:left-0 after:z-10 after:h-[150px] after:w-full after:bg-[linear-gradient(to_top,#fff_0%,rgba(255,255,255,0)_100%)] after:content-[''] dark:after:bg-[linear-gradient(to_top,#1a1a1a_0%,rgba(26,26,26,0)_100%)]"
      data-testid="fade-wrapper"
    >
      {children}
    </div>
  );
};

export default FadeWrapper;
